<acc-page-header>{{ title }}</acc-page-header>
<acc-card>
  <acc-card-body>
    <acc-nav-bar [items]="navItems" [selected]="navItemsSelected" (accChange)="selectNav($event)"></acc-nav-bar>
    <div class="offcanvas-body data-scrollbar mt-3">

      <div class="mb-1 subtitle">{{ 'layout.mode' | translate }}</div>

      <div class="d-flex align-items-center mb-4 gap-x-2">
        <div class="btn btn-border" data-setting="color-mode" data-name="color" data-value="auto"
             [class.active]="mode === 'auto'"
             (click)="updateMode('auto')" (keydown.enter)="updateMode('auto')" tabindex="0">
          <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M7,2V13H10V22L17,10H13L17,2H7Z"></path>
          </svg>
          <span class="ms-2 ">{{ 'layout.mode.auto' | translate }}</span>
        </div>
        <div class="btn btn-border" data-setting="color-mode" data-name="color" data-value="dark"
             [class.active]="mode === 'dark'"
             (click)="updateMode('dark')" (keydown.enter)="updateMode('dark')" tabindex="0">
          <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor"
                  d="M9,2C7.95,2 6.95,2.16 6,2.46C10.06,3.73 13,7.5 13,12C13,16.5 10.06,20.27 6,21.54C6.95,21.84 7.95,22 9,22A10,10 0 0,0 19,12A10,10 0 0,0 9,2Z"></path>
          </svg>
          <span class="ms-2 ">{{ 'layout.mode.dark' | translate }}</span>
        </div>
        <div class="btn btn-border" data-setting="color-mode" data-name="color" data-value="light"
             [class.active]="mode === 'light'"
             (click)="updateMode('light')" (keydown.enter)="updateMode('light')" tabindex="0">
          <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor"
                  d="M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8M12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18M20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31L23.31,12L20,8.69Z"></path>
          </svg>
          <span class="ms-2 ">{{ 'layout.mode.light' | translate }}</span>
        </div>
      </div>

      <div class="mb-1 subtitle">{{ 'layout.color' | translate }}</div>

      <div class="d-flex align-items-center mb-4 gap-x-2">
        <div class="btn btn-border bg-transparent" data-value="theme-color-default" data-info="#3a57e8"
             data-setting="color-mode1" data-name="color" data-bs-toggle="tooltip" data-bs-placement="top" title=""
             [class.active]="color === 'default'"
             [ngbTooltip]=" 'layout.color.default' | translate "
             (click)="updateColor('default')" (keydown.enter)="updateColor('default')" tabindex="0">
          <svg class="customizer-btn icon-32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32">
            <circle cx="12" cy="12" r="10" fill="#3a57e8"></circle>
            <path d="M2,12 a1,1 1 1,0 20,0" fill="#079aa2"></path>
          </svg>
        </div>
        <div class="btn btn-border bg-transparent" data-value="theme-color-blue" data-info="#573BFF"
             data-setting="color-mode1" data-name="color" data-bs-toggle="tooltip" data-bs-placement="top" title=""
             [class.active]="color === 'blue'"
             [ngbTooltip]="'layout.color.blue'|translate"
             (click)="updateColor('blue')" (keydown.enter)="updateColor('blue')" tabindex="0">
          <svg class="customizer-btn icon-32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32">
            <circle cx="12" cy="12" r="10" fill="#00C3F9"></circle>
            <path d="M2,12 a1,1 1 1,0 20,0" fill="#573BFF"></path>
          </svg>
        </div>
        <div class="btn btn-border bg-transparent" data-value="theme-color-gray" data-info="#FD8D00"
             data-setting="color-mode1" data-name="color" data-bs-toggle="tooltip" data-bs-placement="top" title=""
             [class.active]="color === 'gray'"
             [ngbTooltip]="'layout.color.gray'|translate"
             (click)="updateColor('gray')" (keydown.enter)="updateColor('gray')" tabindex="0">
          <svg class="customizer-btn icon-32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32">
            <circle cx="12" cy="12" r="10" fill="#91969E"></circle>
            <path d="M2,12 a1,1 1 1,0 20,0" fill="#FD8D00"></path>
          </svg>
        </div>
        <div class="btn btn-border bg-transparent" data-value="theme-color-red" data-info="#366AF0"
             data-setting="color-mode1" data-name="color" data-bs-toggle="tooltip" data-bs-placement="top" title=""
             [class.active]="color === 'red'"
             [ngbTooltip]="'layout.color.red'|translate"
             (click)="updateColor('red')" (keydown.enter)="updateColor('red')" tabindex="0">
          <svg class="customizer-btn icon-32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32">
            <circle cx="12" cy="12" r="10" fill="#DB5363"></circle>
            <path d="M2,12 a1,1 1 1,0 20,0" fill="#366AF0"></path>
          </svg>
        </div>
        <div class="btn btn-border bg-transparent" data-value="theme-color-yellow" data-info="#6410F1"
             data-setting="color-mode1" data-name="color" data-bs-toggle="tooltip" data-bs-placement="top" title=""
             [class.active]="color === 'yellow'"
             [ngbTooltip]="'layout.color.yellow'|translate"
             (click)="updateColor('yellow')" (keydown.enter)="updateColor('yellow')" tabindex="0">
          <svg class="customizer-btn icon-32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32">
            <circle cx="12" cy="12" r="10" fill="#EA6A12"></circle>
            <path d="M2,12 a1,1 1 1,0 20,0" fill="#6410F1"></path>
          </svg>
        </div>
        <div class="btn btn-border bg-transparent" data-value="theme-color-pink" data-info="#25C799"
             data-setting="color-mode1" data-name="color" data-bs-toggle="tooltip" data-bs-placement="top" title=""
             [class.active]="color === 'pink'"
             [ngbTooltip]="'layout.color.pink'|translate"
             (click)="updateColor('pink')" (keydown.enter)="updateColor('pink')" tabindex="0">
          <svg class="customizer-btn icon-32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32">
            <circle cx="12" cy="12" r="10" fill="#E586B3"></circle>
            <path d="M2,12 a1,1 1 1,0 20,0" fill="#25C799"></path>
          </svg>
        </div>
      </div>

      <div class="mb-1 subtitle">{{ 'layout.sidebar'|translate }}</div>

      <div class="d-flex align-items-center mb-4 gap-x-2">
        <div class="btn btn-border d-block" data-setting="sidebar" data-name="sidebar-color" data-value="sidebar-white"
             [class.active]="sidebar === 'default'"
             (click)="updateSidebar('default')" (keydown.enter)="updateSidebar('default')" tabindex="0">
          <span class="">{{ 'layout.sidebar.default'|translate }}</span>
        </div>
        <div class="btn btn-border d-block" data-setting="sidebar" data-name="sidebar-color" data-value="sidebar-dark"
             [class.active]="sidebar === 'dark'"
             (click)="updateSidebar('dark')" (keydown.enter)="updateSidebar('dark')" tabindex="0">
          <span class="">{{ 'layout.sidebar.dark'|translate }}</span>
        </div>
        <div class="btn btn-border d-block" data-setting="sidebar" data-name="sidebar-color" data-value="sidebar-color"
             [class.active]="sidebar === 'color'"
             (click)="updateSidebar('color')" (keydown.enter)="updateSidebar('color')" tabindex="0">
          <span class="">{{ 'layout.sidebar.color'|translate }}</span>
        </div>
        <div class="btn btn-border d-block" data-setting="sidebar" data-name="sidebar-color"
             data-value="sidebar-transparent"
             [class.active]="sidebar === 'transparent'"
             (click)="updateSidebar('transparent')" (keydown.enter)="updateSidebar('transparent')" tabindex="0">
          <span class="">{{ 'layout.sidebar.transparent'|translate }}</span>
        </div>
      </div>

      <div class="mb-1 subtitle">{{ 'layout.direction'|translate }}</div>

      <div class="d-flex gap-3 mb-4 gap-x-2">
        <div class="text-center"
             (click)="updateDirection('ltr')" (keydown.enter)="updateDirection('ltr')" tabindex="0">
          <img ngSrc="assets/images/settings/dark-ltr.png" alt="ltr"
               class="mode dark-img img-fluid btn-border p-0 flex-column mb-2" [class.active]="direction === 'ltr'"
               data-setting="dir-mode" data-name="dir" data-value="ltr" height="100" width="147" priority>
          <img ngSrc="assets/images/settings/light-ltr.png" alt="ltr"
               class="mode light-img img-fluid btn-border p-0 flex-column mb-2" [class.active]="direction === 'ltr'"
               data-setting="dir-mode" data-name="dir" data-value="ltr" height="100" width="147" priority>
          <span class=" mt-2">{{ 'layout.direction.ltr'|translate }}</span>
        </div>
        <div class="text-center"
             (click)="updateDirection('rtl')" (keydown.enter)="updateDirection('rtl')" tabindex="0">
          <img ngSrc="assets/images/settings/dark-rtl.png" alt=""
               class="mode dark-img img-fluid btn-border p-0 flex-column mb-2" [class.active]="direction === 'rtl'"
               data-setting="dir-mode" data-name="dir" data-value="rtl" height="100" width="147" priority>
          <img ngSrc="assets/images/settings/light-rtl.png" alt=""
               class="mode light-img img-fluid btn-border p-0 flex-column mb-2" [class.active]="direction === 'rtl'"
               data-setting="dir-mode" data-name="dir" data-value="rtl" height="100" width="147" priority>
          <span class="mt-2 ">{{ 'layout.direction.rtl'|translate }}</span>
        </div>
      </div>

    </div>
  </acc-card-body>
</acc-card>
